<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a general modal to be on the page and used when needed
    *
    * @since 20230831
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2023 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div class="modal fade" id="log_back_in_modal" role="dialog">
        <div :class="['modal-dialog', 'modal-xl']">       
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">You have been logged out!</h4>
                </div>
                <div class="modal-body">
                    <p>You are currently logged out of the system, so any changes you have made to this page will not be saved unless you log back in. </p>
                    <div v-if="loading">
                        <i class="fas fa-sync fa-spin"></i>
                    </div>
                    <div v-else-if="!hasLoaded">
                        There was an error loading the log in form, please go to the <a href="/login" target="_href">actual log in form to log back in</a>.
                    </div>
                    <div v-else>
                        <div v-if="maintenanceMode" class="row">
                            <div class="col-md-12 text-danger">
                                The website is currently undergoing scheduled maintenance, so you cannot login. We appreciate your patience.
                            </div>
                        </div>
                        <div v-if="error" class="row">
                            <div class="col-md-12 text-danger">
                                The Username or Password is incorrect
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="username" class="text-black">Username</label>
                            <input id="username" type="text" class="form-control" name="username" value="" required autocomplete="username" autofocus v-model="username">                         
                        </div>

                        <div class="form-group">
                            <label for="password" class="text-black">Password</label>
                            <input id="password" type="password" class="form-control" name="password" required autocomplete="current-password" v-model="password">
                        </div>

                        <div class="form-group row">
                            <div class="col-md-6">
                                    
                            </div>
                            <div class="col-md-6 text-right">   
                                <a class="pl-3 small font-weight-bold" href="" target="_blank" style="color:#e79d19">
                                    Forgotten Password
                                </a>                            
                            </div>
                        </div>
                        <div class="form-group text-center mb-0">                          
                            <button v-if="loggingIn" type="button" class="btn btn-front rounded-pill">
                                Logging In <i class="fas fa-sync fa-spin"></i>
                            </button> 
                            <button v-else type="button" class="btn btn-front rounded-pill" @click="logIn()">
                                Login
                            </button>                        
                        </div>

                        <p v-if="ssoLink.length > 0" class="mt-3">If you are a student or staff member, use the below button to log in with your college account.</p>
                        <a v-if="ssoLink.length > 0" class="btn btn-primary" :href="ssoLink" target="_blank">Log in with college account</a>

                        <p v-if="ssoLink.length > 0" class="mt-3" @click="closeModal()">If you have already logged back in, click here to get back to the page.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
            getRoute: String
        },
        data() {
            return {
                hasLoaded: false,
                loading: false,
                loggingIn: false,
                ssoLink: '',
                loginRoute: '',
                maintenanceMode: false,
                error: false,
                username: '',
                password: '',
                shown: false,
            }
        },
        computed: {
        },
        methods: {
            /**
             * shows the insurance modal
             * 
             * @param Object insurance the insurance to display on the modal
             */
            showModal: function(){
                if(!this.shown){
                    this.shown = true;
                    $('#log_back_in_modal').modal('show');
                    $('#log_back_in_modal').data('bs.modal')._config.backdrop = 'static';
                    $('#log_back_in_modal').data('bs.modal')._config.keyboard = false;
                    this.getData(true);
                }
            },
            /**
             * shows the insurance modal
             * 
             * @param Object insurance the insurance to display on the modal
             */
            closeModal: function(){
                if(this.shown){
                    this.shown = false;
                    $('#log_back_in_modal').modal('hide');
                }
                this.$reportJobs.push({
                    checkLoggedInJob: true,
                });
            },
            /**
            * gets the data for the tab
            */
            getData: async function (refresh = false) {
                if((!this.hasLoaded || refresh) && !this.loading){
                    console.log('getting data');
                    this.loading = true;
                    if(refresh){
                        this.hasLoaded = false;
                    }
                    try {
                        const { data } = await this.$http.get(this.getRoute);
                        
                        if(data.error !== undefined){
                            console.log('An error occurred getting the data');
                            console.log(data.error);
                        } else if(data !== undefined){
                            console.log('setting data');
                            this.setData(data);
                        } else {
                            console.log(data);
                        }
                    } catch(error) {
                        console.log('An error occurred getting the data');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                    }
                    this.loading = false;
                }
            },
            setData: function(data){
                this.ssoLink = data.ssoLink;
                this.loginRoute = data.loginRoute;
                this.maintenanceMode = data.maintenanceMode;
                this.hasLoaded = true;
            },
            /**
            * gets the data for the tab
            */
            logIn: async function () {
                this.loggingIn = true;
                this.error = false;
                try {
                    const { data } = await this.$http.put(this.loginRoute, {
                        username: this.username,
                        password: this.password
                    });
                    
                    if(data.error !== undefined){
                        console.log('An error occurred logging in');
                        console.log(data.error);
                        this.error = true;
                    } else if(data !== undefined){
                        if(data.loggedIn){
                            this.closeModal();
                        } else {
                            this.error = true;
                        }
                    } else {
                        console.log(data);
                        this.error = true;
                    }
                } catch(error) {
                    console.log('An error occurred logging in');
                    if(error.response !== undefined){
                        console.log('File: ' + error.response.data.file);
                        console.log('Line: ' + error.response.data.line);
                        console.log('Message: ' + error.response.data.message);
                        console.log('Exception: ' + error.response.data.exception);
                        console.log(error.response.data.trace);
                    } else {
                        console.log(error);
                    }
                    this.error = true;
                }
                this.loggingIn = false;
            },
        }
    }
</script>